import { useEffect, useState } from "react";
import { getGoods } from "pages/dashboard/license/service";
import { useDebouncedCallback } from "use-debounce";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { ConfirmModalStyles } from "lib/constants";
import { createOrgOrder, getOrderInfo } from "lib/actions";
import { SvgArrow } from "ui/svgs";
import { clsx } from "clsx";
import { getCurrencySymbol } from "lib/utils";
import { showToast } from "ui/components/common";
import { cancelOrder, getMoreCredits } from "pages/dashboard/license/service";
import { Skeleton } from "antd";
//import Modal from "react-modal";
import { Modal } from "antd";

export default function Page() {
  const { state } = useLocation();
  const { id } = useParams();
  const customerOrgId = id!;
  const [aiUnits, setAiUnits] = useState([]);
  const [goodsId, setGoodsId] = useState("");
  const [goodsVersion, setGoodsVision] = useState([]);
  const [selectedGoodUnitId, setSelectedGoodUnitId] = useState("");
  const [payingModalOpen, setPayingModalOpen] = useState(false);
  const navigate = useNavigate();
  const [orderId, setOrderId] = useState(0);
  const [redirectUrl, setRedirectUrl] = useState("");
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getGoods("goods_type_ai_quota").then((res) => {
      setLoading(false);
      if (res.status !== 200) {
        showToast(
          1,
          "There was a problem loading data. Please try again later.",
        );
        return;
      }

      const aiGood = res?.data?.goodsInfos?.find(
        (good) => good.type === "goods_type_ai_quota",
      );
      setGoodsId(aiGood?.goodsId);
      setGoodsVision(aiGood?.version);
      const aiUnits = aiGood?.goodsUnits.goods_unit_type_ai_quota.units;
      setAiUnits(aiUnits);
      setSelectedGoodUnitId(aiUnits?.at(0)?.goodsUnitId || "");
    });
  }, []);

  const selectedGoodUnit = aiUnits?.find(
    (unit) => unit.goodsUnitId === selectedGoodUnitId,
  );

  const handleCheckout = useDebouncedCallback(async () => {
    const request = {
      data: [
        {
          orgId: parseInt(customerOrgId),
          updateInfo: {
            goodsId: goodsId,
            goodsVersion: goodsVersion,
            units: [
              {
                unitId: selectedGoodUnit?.goodsUnitId,
                unitType: selectedGoodUnit?.goodsUnitType,
              },
            ],
          },
        },
      ],
      price: {
        amount: selectedGoodUnit?.price?.amount,
        currency: selectedGoodUnit?.price?.currency,
      },
    };
    setCheckoutLoading(true);
    try {
      const res = await createOrgOrder(request);
      setCheckoutLoading(false);
      const { orderId, redirectUrl } = res;
      if (!redirectUrl || !orderId) {
        showToast(1, "Fail to create order. Please try again");
        return;
      }
      window.open(redirectUrl, "_blank");
      setRedirectUrl(redirectUrl);
      setOrderId(orderId);
      setPayingModalOpen(true);
    } catch (error) {
      console.error(error);
      showToast(1, "Fail to create order. Please try again");
    }
    setCheckoutLoading(false);
  }, 100);

  const handlePayment = async () => {
    try {
      const res = await getOrderInfo(customerOrgId, orderId);
      if (res?.data?.status === "confirmed") {
        showToast(0, "The licenses have been assigned successfully!");
        navigate(`/dashboard/license/ai`);
      } else {
        showToast(1, "No payment success detected. Please try again.");
      }
    } catch (error) {
      console.error(error);
      showToast(1, "Failed to obtain order information.  Please try again.");
    }
  };

  const cancelPayment = async () => {
    const res = await cancelOrder(orderId, customerOrgId);
    if (res.status !== 200) {
      showToast(1, "Failed to cancel the order. Please try again.");
      return;
    }
    showToast(0, "The order have been cancelled successfully");
    setPayingModalOpen(false);
  };

  const handleMoreCredits = async () => {
    const res = await getMoreCredits();
    if (res.status !== 200) {
      showToast(
        1,
        "There was a problem submitting your request. Please try again later.",
      );
      return;
    }

    Modal.success({
      title: "Successfully",
      content: (
        <p className="text-base break-normal mb-2">
          Your application for more credits has been successfully submitted!
        </p>
      ),
      icon: null,
      centered: true,
      okText: "Got it",
      okButtonProps: {
        className: "primaryButton ",
      },
    });
  };

  if (loading) {
    return (
      <div className="w-full h-full flex justify-center">
        <div className="w-[600px] mt-24">
          <Skeleton />
          <Skeleton.Button className="float-right mt-4" size={"large"} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center w-full h-full md:pt-20 overflow-y-auto max-h-full">
      <div className=" max-w-full p-4">
        <div className="bg-[#FAFAFA] rounded-2xl p-6 w-fit max-w-full">
          <p className="font-semibold text-xl">Purchase AI Credit</p>
          <div className="flex gap-5 justify-center mt-5 flex-wrap">
            {aiUnits?.map((unit, i) => (
              <button
                key={unit.goodsUnitId}
                className={clsx(
                  "relative w-[130px] flex justify-center items-center cursor-pointer border-2 rounded-2xl  gap-1 flex-col py-3",
                  selectedGoodUnitId === unit.goodsUnitId
                    ? "border-[#3E83F6] bg-[#DCE7FD]"
                    : "border-transparent bg-white hover:bg-[#DCE7FD]",
                )}
                onClick={() => setSelectedGoodUnitId(unit.goodsUnitId)}
              >
                <p className="font-semibold">
                  {getCurrencySymbol(unit.price?.currency) +
                    (unit.price?.amount / 100)?.toLocaleString()}
                </p>
                <p className="text-sm">for</p>
                <p className="font-semibold">
                  {(+unit?.quota?.at(0)?.amount)?.toLocaleString()}
                </p>
                {i === aiUnits.length - 1 && (
                  <div className="flex justify-end absolute -top-[24px] left-1/2 -translate-x-1/2">
                    <p className="w-fit text-nowrap font-semibold bg-[#e4eaf8] text-[#3E83F6] text-xs px-1 rounded py-0.5">
                      Best Value
                    </p>
                  </div>
                )}
              </button>
            ))}
          </div>
          <div className="flex items-center justify-center gap-2 font-semibold mt-4">
            <p className="text-[#222222] font-semibold text-xl">Current:</p>
            <p className="text-[34px]">
              {state?.credits.toLocaleString() || 0}
            </p>
            <SvgArrow width="20" className="fill-[#222222] mt-0.5" />
            <p className="text-[34px]">
              {(
                state?.credits +
                parseInt(selectedGoodUnit?.quota?.at(0)?.amount)
              )?.toLocaleString()}
            </p>
          </div>
          <div className="flex items-center justify-center  mt-4 text-[#3E83F6] font-semibold">
            <button
              className="px-6 py-4 rounded-2xl bg-[#DCE7FD] hover:bg-[#e2ecfd]"
              onClick={handleMoreCredits}
            >
              Contact Sales for More Credits
            </button>
          </div>
        </div>

        <p className="text-right font-semibold pr-6 mt-8 text-[34px]">
          <span className="mr-6">Total</span>
          <span className="">
            {getCurrencySymbol(selectedGoodUnit?.currency) +
              (selectedGoodUnit?.price?.amount / 100)?.toLocaleString()}
          </span>
        </p>
        <div className="mt-8">
          <button
            className={clsx(
              "float-right flex justify-center h-[56px] w-[122px] items-center rounded-2xl bg-blue-600 text-base font-medium text-white transition-colors hover:bg-blue-500 disabled:bg-blue-200 disabled:hover:bg-blue-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600",
            )}
            onClick={handleCheckout}
            disabled={checkoutLoading}
          >
            {checkoutLoading ? (
              <div
                className="ml-1 text-white  inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                role="status"
              ></div>
            ) : (
              "Checkout"
            )}
          </button>
        </div>
      </div>
      <Modal
        open={payingModalOpen}
        footer={null}
        closable={false}
        width={550}
        centered
      >
        <h1 className="text-xl font-bold">Processing Payment</h1>
        <div className="text-base mt-4">
          Please complete the payment within Stripe. If you have successfully
          paid, click the &quot;Payment Completed&quot; button. lf the payment
          page is not opened, click the &quot;Retry Payment&quot; button.
        </div>

        <div className="flex justify-end items-end mt-6">
          <button
            className="rounded-2xl bg-white px-6 py-4 border border-blue-500 hover:border-blue-400 text-sm  transition-colors text-blue-500 hover:text-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
            onClick={() => {
              cancelPayment();
            }}
          >
            Cancel Payment
          </button>
          <a
            className="ml-4 rounded-2xl bg-white px-6 py-4 border border-blue-500 hover:border-blue-400 text-sm  transition-colors text-blue-500 hover:text-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
            href={redirectUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Retry Payment
          </a>
          <button
            className="ml-4 rounded-2xl px-6 py-4 bg-blue-500 text-sm font-medium text-white transition-colors hover:bg-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
            onClick={() => {
              handlePayment();
            }}
          >
            Payment Completed
          </button>
        </div>
      </Modal>
    </div>
  );
}
